import range from 'lodash/range'

/** Take in personalityObject and return [] of each number value */
export function getPersonalityOptionsArray(personalityObj = { regular: 1}) {

  let payload = [];

  //For each value in the object, put that many copies of the key into the payload array
  Object.keys(personalityObj).forEach(key => {
    range(personalityObj[key]).forEach(point => {
      payload.push(key);
    });
  });

  return payload;
}


// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-personality-options-array.js